export default "__VITE_ASSET__86219936__"